import { isMobile } from "./is-mobile";

export const setHtmlAttributes = (culture: string): void => {
  // set is-web/is-mobile class name depends on device type
  const className = isMobile() ? 'is-mobile' : 'is-web';
  document.documentElement.classList.add(className);

  // set dir attribute depends on culture(language)
  const RIGHT_ALIGNED_LANGUAGES = ['fa', 'ar', 'heb'];
  const isRightAligned = RIGHT_ALIGNED_LANGUAGES.includes(culture);
  document.documentElement.setAttribute('dir', isRightAligned ? 'rtl' : 'ltr');
};
